import React from "react";
import { Paper, type PaperProps } from "@mui/material";
import { radius, shadows, transition } from "../../config/theme";

interface AccentCardProps extends PaperProps {
  /** Optional left-border accent color. Omit for a plain card. */
  accentColor?: string;
  /** Apply a subtle hover lift. */
  interactive?: boolean;
}

/**
 * Standard card surface: rounded corners, design-system shadow, and an
 * optional left accent border. Replaces the repeated Paper + padding +
 * border-radius + left-accent pattern scattered across pages.
 */
export default function AccentCard({
  accentColor,
  interactive = false,
  sx,
  children,
  ...rest
}: AccentCardProps) {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: `${radius.md}px`,
        border: "1px solid",
        borderColor: "divider",
        boxShadow: shadows.card,
        ...(accentColor ? { borderLeft: `3px solid ${accentColor}` } : {}),
        ...(interactive
          ? {
              transition: transition(["box-shadow", "transform"]),
              "&:hover": { boxShadow: shadows.cardHover, transform: "translateY(-1px)" },
            }
          : {}),
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Paper>
  );
}
